/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ t: NonNullable<unknown> }} Ambient_Temperature_ValueInputs */



/**
* | output |
* | --- |
* | "- Ambient temp.: {t}°C" |
*
* @param {Ambient_Temperature_ValueInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const ambient_temperature_value = /** @type {((inputs: Ambient_Temperature_ValueInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ambient_Temperature_ValueInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`- Ambient temp.: ${i?.t}°C`)
	return /** @type {LocalizedString} */ (`- T° d'ambiance: ${i?.t}°C`)
});